import React, { useCallback } from 'react';
import { EntityHeaderDto } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/EntityDetails';
import { ImageInfo } from '@decisions/server/DecisionsFramework/ServiceLayer/Services/Image';
import './EntityHeaderView.less';
import { getImageInfoUrl } from 'utils/ImageUtils';
import classNames from 'classnames';

interface IEntityHeaderViewProps extends React.HTMLProps<HTMLLIElement> {
  entity: EntityHeaderDto;
  onViewClick?: (id: string, typeName: string, clickEvent: React.MouseEvent) => void;
}

const getHeaderClassName = (className?: string, isActionable?: boolean) =>
  classNames('dp-entity-header-view', className, {
    'dp-entity-header-view--actionable': isActionable,
  });

export function EntityHeaderView({ entity, onViewClick, ...props }: IEntityHeaderViewProps) {
  const contextClick = useCallback(
    (event: React.MouseEvent) => {
      onViewClick?.(entity.EntityId, entity.TypeName, event);
    },
    [entity, onViewClick]
  );

  return (
    <li onClick={contextClick} className={getHeaderClassName(props.className, !!onViewClick)}>
      <div className="dp-entity-header-view__icon" style={getImageBackground(entity.Icon)}></div>
      <div className="dp-entity-header-view__text" title={entity.Name}>
        {entity.Name}
      </div>
    </li>
  );
}

function getImageBackground(icon: ImageInfo) {
  const url = getImageInfoUrl(icon);

  return {
    background: `url(${url}) no-repeat center center / 24px auto`,
  };
}
